import { useState, useCallback } from "react";
import {
  treasuryReportingService,
  TreasuryEntry,
  TreasurySummary,
} from "../../../../services/treasuryReportingService";

interface FilterParams {
  date_from?: string;
  date_to?: string;
}

export const useTreasuryData = () => {
  const [entries, setEntries] = useState<TreasuryEntry[]>([]);
  const [totalEntries, setTotalEntries] = useState(0);
  const [summary, setSummary] = useState<TreasurySummary | null>(null);
  const [loading, setLoading] = useState(false);

  const loadEntries = useCallback(async (params: FilterParams & { skip: number; limit: number }) => {
    setLoading(true);
    try {
      const res = await treasuryReportingService.listEntries(params);
      setEntries(res.data?.entries || []);
      setTotalEntries(res.data?.total || 0);
    } catch (err) {
      console.error("Error loading treasury entries", err);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadSummary = useCallback(async (params: FilterParams = {}) => {
    setLoading(true);
    try {
      const res = await treasuryReportingService.summary(params);
      setSummary(res.data || null);
    } catch (err) {
      console.error("Error loading treasury summary", err);
    } finally {
      setLoading(false);
    }
  }, []);

  const createEntry = async (data: Partial<TreasuryEntry>) => {
    return await treasuryReportingService.createEntry(data);
  };

  const updateEntry = async (id: string, data: Partial<TreasuryEntry>) => {
    return await treasuryReportingService.updateEntry(id, data);
  };

  const deleteEntry = async (id: string) => {
    return await treasuryReportingService.deleteEntry(id);
  };

  const downloadExcel = async (params: FilterParams) => {
    return await treasuryReportingService.downloadExcel(params);
  };

  return {
    entries,
    totalEntries,
    summary,
    loading,
    loadEntries,
    loadSummary,
    createEntry,
    updateEntry,
    deleteEntry,
    downloadExcel,
  };
};
